<header class="mt-3">
    <form class="card content" [formGroup]="formGroup">
        <div class="flex flex-row-start">
            <div class="form-group mr-3" [ngClass]="{'has-error': formGroup.get('validFrom')?.invalid && (formGroup.get('validFrom')?.dirty || formGroup.get('validFrom')?.touched)}">
                <label class="inline-block mb-1 font-semibold text-xs uppercase text-secondary-900">{{ '#KUNDEN_KONDITIONSLISTE.LIST.VALID_FROM' | translate }}</label>
                <soft-date-input formControlName="validFrom" placeholder="{{ '#KUNDEN_KONDITIONSLISTE.LIST.DATE' | translate }}" (valueChange)="onValidFromChange($event ?? '')"></soft-date-input>
            </div>
            <div class="form-group mr-3" [ngClass]="{'has-error': formGroup.get('newPriceDate')?.invalid && (formGroup.get('newPriceDate')?.dirty || formGroup.get('newPriceDate')?.touched)}">
                <label class="inline-block mb-1 font-semibold text-xs uppercase text-secondary-900">{{ '#KUNDEN_KONDITIONSLISTE.LIST.NEW_PRICE_DATE' | translate }}</label>
                <soft-date-input formControlName="newPriceDate" placeholder="{{ '#KUNDEN_KONDITIONSLISTE.LIST.DATE' | translate }}"></soft-date-input>
            </div>
        </div>
        <div class="flex flex-row-end">
            <div class="flex flex-row space-x-4">
                <!-- <button class="soft-button secondary custom-size text-center" (click)="onSubmit('new')" [disabled]="!changedProducts?.length || formGroup.invalid">
                    <span class="fa-regular fa-plus text-lg mb-1"></span>
                    <div>Erstellen</div>
                </button> -->
                <button class="soft-button primary custom-size text-center" (click)="onSubmit('save')" [disabled]="!changedProducts?.length || formGroup.invalid">
                    <span class="fa-regular fa-floppy-disk text-lg mb-1"></span>
                    <div>{{ '#KUNDEN_KONDITIONSLISTE.LIST.SAVE' | translate }}</div>
                </button>
            </div>
        </div>
    </form>
    <div class="mt-1 text-right text-gray-500 text-xs">{{ '#KUNDEN_KONDITIONSLISTE.LIST.GROSS_PRICE_INFO' | translate }}</div>
</header>
